import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import { Box, LinearProgress, Typography } from "@mui/material";
import { useJob } from "../../model/hooks";
var ACCENT = "rgb(255, 184, 1)";
var ACCENT_BG = "rgba(255, 184, 1, 0.08)";
var ACCENT_BORDER = "rgba(255, 184, 1, 0.2)";
var SUCCESS = "#22C55E";
var ERROR = "#EF4444";
var WARN = "#FBBF24";
var STATUS_LABEL = {
    queued: "Queued",
    running: "Running",
    done: "Completed",
    failed: "Failed",
};
export var JobProgress = function (_a) {
    var jobId = _a.jobId, label = _a.label, onDone = _a.onDone;
    var job = useJob(jobId).data;
    if (!job) {
        return (_jsx(Box, { sx: {
                background: "rgba(255,255,255,0.02)",
                border: "1px solid #1F2937",
                borderRadius: "10px",
                p: 2,
            }, children: _jsx(Typography, { sx: { color: "rgba(255,255,255,0.45)", fontSize: 12 }, children: "Loading job\u2026" }) }));
    }
    if (job.status === "done")
        onDone === null || onDone === void 0 ? void 0 : onDone();
    var percent = job.total > 0 ? Math.round((job.processed / job.total) * 100) : 0;
    var statusColor = job.status === "done"
        ? SUCCESS
        : job.status === "failed"
            ? ERROR
            : job.status === "queued"
                ? WARN
                : ACCENT;
    var StatusIcon = job.status === "done"
        ? CheckCircleIcon
        : job.status === "failed"
            ? ErrorOutlineIcon
            : HourglassEmptyIcon;
    return (_jsxs(Box, { sx: {
            background: ACCENT_BG,
            border: "1px solid ".concat(ACCENT_BORDER),
            borderRadius: "12px",
            p: 2,
        }, children: [_jsxs(Box, { display: "flex", alignItems: "center", gap: 1.5, mb: 1.5, children: [_jsx(StatusIcon, { sx: { color: statusColor, fontSize: 18 } }), _jsxs(Box, { flex: 1, minWidth: 0, children: [_jsx(Typography, { sx: { color: "#fff", fontWeight: 600, fontSize: 13 }, children: label !== null && label !== void 0 ? label : job.type.replace(/-/g, " ") }), _jsxs(Typography, { sx: { color: "rgba(255,255,255,0.5)", fontSize: 11 }, children: [STATUS_LABEL[job.status], " \u00B7 ", job.processed, " / ", job.total, " (", percent, "%)"] })] })] }), _jsx(LinearProgress, { variant: job.status === "queued" ? "indeterminate" : "determinate", value: percent, sx: {
                    height: 6,
                    borderRadius: 3,
                    background: "rgba(255,255,255,0.05)",
                    "& .MuiLinearProgress-bar": { background: statusColor, borderRadius: 3 },
                } }), job.error && (_jsx(Typography, { sx: { color: ERROR, fontSize: 11, mt: 1 }, children: job.error })), job.message && job.status !== "done" && (_jsx(Typography, { sx: { color: "rgba(255,255,255,0.45)", fontSize: 11, mt: 1 }, children: job.message }))] }));
};
